<template>
  <div class="yxbx_wrap">
    <div class="yxbx_box">
      <div class="yxbx_list">
        <div class="bx_item">
          <div class="title_box">
            <div class="title">表现</div>

            <el-select
              v-model="bxValue"
              size="small"
              class="bx_select"
              @change="bxSelectChange"
            >
              <el-option :value="7" label="7日" />
              <el-option :value="30" label="30日" />
              <el-option :value="90" label="90日" />
            </el-select>
          </div>

          <div class="item_box">
            <div class="box">
              <div class="sy" :class="{ sy_: bxList.yieldRate < 0 }">
                {{ bxList.yieldRate >= 0 ? "+" : ""
                }}{{ COMMON.formatToFixed(bxList.yieldRate) }}%
              </div>

              <div class="title_box">
                <div class="title">
                  收益率

                  <el-tooltip
                    effect="dark"
                    content="该策略在选定时间范围内的已卖出个股所有收益相加"
                    placement="right"
                  >
                    <img
                      class="icon"
                      src="@/assets/ai_stock/strategy/icon.png"
                    />
                  </el-tooltip>
                </div>
              </div>
            </div>

            <div class="box">
              <div class="sy" :class="{ sy_: bxList.winRate < 0 }">
                {{ COMMON.formatToFixed(bxList.winRate) }}%
              </div>

              <div class="title_box">
                <div class="title">
                  胜率

                  <el-tooltip
                    effect="dark"
                    content="该策略在选定时间范围内止盈个数除以总推出个数乘以100%"
                    placement="right"
                  >
                    <img
                      class="icon"
                      src="@/assets/ai_stock/strategy/icon.png"
                    />
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="period_item">
          <div class="title_box">
            <div class="title">
              持股周期

              <el-tooltip
                effect="dark"
                content="该策略选出个股从入选到止盈或止损的天数"
                placement="right"
              >
                <img
                  class="icon"
                  src="@/assets/ai_stock/strategy/icon.png"
                />
              </el-tooltip>
            </div>
          </div>

          <div class="period_box">
            <div class="period_echart" ref="period_echart"></div>
          </div>
        </div>
      </div>

      <div class="yield_box">
        <div class="title_box">
          <div class="title">收益率</div>

          <el-select
            v-model="syValue"
            size="small"
            class="bx_select"
            @change="sySelectChange"
          >
            <el-option :value="7" label="7日" />
            <el-option :value="30" label="30日" />
            <el-option :value="90" label="90日" />
          </el-select>
        </div>

        <div class="sy_box">
          <div class="sy_echart" ref="sy_echart"></div>
        </div>
      </div>
    </div>

    <div class="armory_box" v-if="armoryList.length > 0">
      <div class="title_box">
        <div class="title">
          英雄榜

          <el-tooltip effect="dark" placement="right">
            <template #content>
              该策略前{{ armoryDay }}日收益排行前{{ armoryLimit }}个股
            </template>

            <img class="icon" src="@/assets/ai_stock/strategy/icon.png" />
          </el-tooltip>
        </div>
      </div>

      <div class="armory_list">
        <div
          class="armory_item"
          v-for="(item, index) in armoryList"
          :key="index"
        >
          <div class="stock">{{ item.stockName }}/{{ item.stockCode }}</div>

          <div class="deal_box">
            <div class="left">
              <div class="box">
                <div>{{ item.buyTime }}</div>
                <div>买入</div>
                <div>买入价格：{{ COMMON.formatToFixed(item.buyPrice) }}</div>
              </div>

              <div class="box sell_box">
                <div>{{ item.sellTime }}</div>
                <div>卖出</div>
                <div>卖出价格：{{ COMMON.formatToFixed(item.sellPrice) }}</div>
              </div>
            </div>

            <div class="right">
              <div class="cycle">持股周期：{{ item.holdDay }}天</div>

              <div class="profit">
                实现利润：
                <span :class="{ sp: item.profit < 0 }">
                  {{ item.profit >= 0 ? "+" : ""
                  }}{{ COMMON.formatToFixed(item.profit) }}%
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { markRaw } from "vue";
import * as echarts from "echarts";

export default {
  props: {
    infoList: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      bxValue: 7,
      syValue: 7,
      bxList: {
        yieldRate: 0,
        winRate: 0,
      },
      syChart: null,
      syList: [],
      cycleChart: null,
      cycleList: [],
      armoryDay: 30,
      armoryLimit: 10,
      armoryList: [],
    };
  },
  computed: {
    cycleDataList() {
      return this.cycleList.map((item) => ({
        name: item.name,
        value: item.rate,
      }));
    },
  },
  created() {},
  mounted() {
    this.getStrategyPerformance(); // 获取 策略 表现
    this.getStrategyYield(); // 获取 策略 收益率
    this.getStrategyCycle(); // 获取 策略 持股周期
    this.getStrategyArmory(); // 获取 策略 英雄榜
  },
  methods: {
    // 获取 策略 表现
    getStrategyPerformance() {
      let data = {
        strategyId: this.infoList.id,
        day: this.bxValue,
      };

      this.API.CLOUDGet("quant/api/ai-strategy/performance", data).then(
        (res) => {
          // console.log(res);
          let datas = res.data?.data;
          // console.log(datas);

          if (datas) {
            this.bxList = datas;
          }
        }
      );
    },

    // 获取 策略 收益率
    getStrategyYield() {
      let data = {
        strategyId: this.infoList.id,
        day: this.syValue,
      };

      this.API.CLOUDGet("quant/api/ai-strategy/yield", data).then((res) => {
        // console.log(res);
        let datas = res.data?.data;
        // console.log(datas);

        if (datas) {
          this.syList = datas;

          this.syInitEcharts(); // 收益率 图表 init
        }
      });
    },

    // 获取 策略 持股周期
    getStrategyCycle() {
      let data = {
        strategyId: this.infoList.id,
      };

      this.API.CLOUDGet("quant/api/ai-strategy/hold-cycle", data).then(
        (res) => {
          // console.log(res);
          let datas = res.data?.data;
          // console.log(datas);

          if (datas) {
            this.cycleList = datas;

            this.cycleInitEcharts(); // 选股周期 图表 init
          }
        }
      );
    },

    // 获取 策略 英雄榜
    getStrategyArmory() {
      let data = {
        strategyId: this.infoList.id,
        day: this.armoryDay,
        limit: this.armoryLimit,
      };

      this.API.CLOUDGet("quant/api/ai-strategy/armory", data).then((res) => {
        // console.log(res);
        let datas = res.data?.data;
        // console.log(datas);

        if (datas) {
          this.armoryList = datas;
        }
      });
    },

    // 表现 select 状态改变
    bxSelectChange(value) {
      // console.log(value);

      this.getStrategyPerformance(); // 获取 策略 表现
    },

    // 收益率 select 状态改变
    sySelectChange(value) {
      // console.log(value);

      this.getStrategyYield(); // 获取 策略 收益率
    },

    // 选股周期 图表 init
    cycleInitEcharts() {
      let chartDom = this.$refs.period_echart;
      this.cycleChart = echarts.init(chartDom);

      let option = {
        color: ["#5386DF", "#F8C548", "#F9884C", "#F45051", "#D06AD5"],
        tooltip: {
          trigger: "item",
          formatter: '{a} <br/>{b}：<b>{d}%</b>'
        },
        // legend: {
        //   orient: "vertical",
        //   left: "right",
        //   align: "left", // 确保图标在文字左侧（默认值，可省略）
        //   textStyle: {
        //     color: "#fff", // 文字颜色
        //     // padding: [0, 0, 0, 5], // 调整文字与图标的间距（左内边距）
        //   },
        //   icon: "circle", // 图标为小圆点
        //   itemWidth: 8, // 小圆点宽度
        //   itemHeight: 8, // 小圆点高度
        //   itemGap: 10, // 图例项之间的间距
        //   symbolKeepAspect: false, // 防止图标变形
        // },
        series: [
          {
            name: "持股周期",
            type: "pie",
            radius: ["50%", "70%"],
            itemStyle: {
              borderRadius: 0,
              borderColor: "#050A1A",
              borderWidth: 1,
            },
            label: {
              color: "#fff",
            },
            labelLine: {
              // show: false,
            },
            data: this.cycleDataList,
          },
        ],
      };

      this.cycleChart.setOption(option);

      window.addEventListener("resize", () => this.cycleChart?.resize());
    },

    // 收益率 图表 init
    syInitEcharts() {
      let that = this;
      let chartDom = this.$refs.sy_echart;
      this.syChart = markRaw(echarts.init(chartDom));

      let datas = this.syList.map((item) => item.day);
      let profits = this.syList.map((item) => item.yield);

      let maxValue = Math.max(...profits);
      let minValue = Math.min(...profits);

      // 计算零值在Y轴上的相对位置
      let zeroPosition = 0.5; // 默认中间位置
      let lineGradientStops = [];
      let areaGradientStops = [];

      if (minValue >= 0) {
        // 所有数据都 >= 0，整体使用红色
        zeroPosition = 1; // 零线在底部
        lineGradientStops = [
          { offset: 0, color: "rgba(255, 0, 0, 0.8)" },
          { offset: 1, color: "rgba(255, 0, 0, 0.8)" },
        ];
        areaGradientStops = [
          { offset: 0, color: "rgba(255, 0, 0, 0.3)" },
          { offset: 1, color: "rgba(255, 0, 0, 0.1)" },
        ];
      } else if (maxValue <= 0) {
        // 所有数据都 <= 0，整体使用绿色
        zeroPosition = 0; // 零线在顶部
        lineGradientStops = [
          { offset: 0, color: "rgba(38, 163, 116, 0.8)" },
          { offset: 1, color: "rgba(38, 163, 116, 0.8)" },
        ];
        areaGradientStops = [
          { offset: 0, color: "rgba(38, 163, 116, 0.1)" },
          { offset: 1, color: "rgba(38, 163, 116, 0.3)" },
        ];
      } else {
        // 数据跨越零值，需要计算零值位置
        zeroPosition = 1 - (0 - minValue) / (maxValue - minValue);
        lineGradientStops = [
          { offset: 0, color: "rgba(255, 0, 0, 0.8)" },
          { offset: zeroPosition - 0.001, color: "rgba(255, 0, 0, 0.8)" },
          { offset: zeroPosition, color: "rgba(127, 127, 127, 0.5)" },
          { offset: zeroPosition + 0.001, color: "rgba(38, 163, 116, 0.8)" },
          { offset: 1, color: "rgba(38, 163, 116, 0.8)" },
        ];
        areaGradientStops = [
          { offset: 0, color: "rgba(255, 0, 0, 0.3)" },
          { offset: zeroPosition - 0.005, color: "rgba(255, 0, 0, 0.1)" },
          { offset: zeroPosition, color: "rgba(127, 127, 127, 0)" },
          { offset: zeroPosition + 0.005, color: "rgba(38, 163, 116, 0.1)" },
          { offset: 1, color: "rgba(38, 163, 116, 0.3)" },
        ];
      }

      let option = {
        grid: {
          top: "10%", // 上边距
          right: "3px", // 右边距
          bottom: "0", // 下边距（关键调整项）
          left: "3px", // 左边距
          containLabel: true, // 确保坐标轴标签在 grid 内
        },
        xAxis: {
          type: "category",
          data: datas,
          show: false,
          boundaryGap: false
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            // console.log(params);

            // params 是一个数组，包含当前轴上的所有数据点
            let date = params[0].axisValue; // 获取当前 hover 的日期
            let value = params[0].data; // 获取当前 hover 的值
            let color = value >= 0 ? "#ff0000" : "#26a374"; // 根据正负值设置颜色

            // 自定义浮窗内容
            return `
              <div>${date}</div>
              <div>收益率: 
                <span style="color:${color};font-weight:bold;">${
              value >= 0 ? "+" : ""
            }${that.COMMON.formatToFixed(value)}%</span>
              </div>
            `;
          },
        },
        yAxis: {
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed", // 默认为虚线
              color: "gray",
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#86909C", // 设置 y 轴线的颜色
            },
          },
        },
        series: [
          {
            name: "收益率",
            type: "line",
            data: profits,
            showSymbol: false,
            smooth: true,
            itemStyle: {
              color: (params) => {
                return params.data >= 0 ? "#ff0000" : "#26a374";
              },
            },
            lineStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                lineGradientStops
              ),
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                areaGradientStops
              ),
            },
          },
        ],
      };

      this.syChart.setOption(option);

      window.addEventListener("resize", () => this.syChart?.resize());
    },
    syInitEcharts_v1() {
      let that = this;
      let chartDom = this.$refs.sy_echart;
      this.syChart = markRaw(echarts.init(chartDom));

      let option = {
        grid: {
          top: "10%", // 上边距
          right: "0", // 右边距
          bottom: "0", // 下边距（关键调整项）
          left: "3px", // 左边距
          containLabel: true, // 确保坐标轴标签在 grid 内
        },
        xAxis: {
          type: "category",
          data: this.syList.map((item) => item.day),
          show: false,
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            // console.log(params);

            // params 是一个数组，包含当前轴上的所有数据点
            let date = params[0].axisValue; // 获取当前 hover 的日期
            let value = params[0].data; // 获取当前 hover 的值
            let color = value >= 0 ? "#ff0000" : "#26a374"; // 根据正负值设置颜色

            // 自定义浮窗内容
            return `
              <div>${date}</div>
              <div>收益率: 
                <span style="color:${color};font-weight:bold;">${
              value >= 0 ? "+" : ""
            }${that.COMMON.formatToFixed(value)}%</span>
              </div>
            `;
          },
        },
        yAxis: {
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed", // 默认为虚线
              color: "gray",
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#86909C", // 设置 y 轴线的颜色
            },
          },
        },
        series: [
          {
            name: "收益率",
            data: this.syList.map((item) => item.yield),
            type: "line",
            showSymbol: false,
            smooth: true,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(255, 0, 0, 0.1)" }, // 红色渐变
                { offset: 1, color: "rgba(38, 163, 116, 0.1)" }, // 绿色渐变
              ]),
            },
          },
        ],
        visualMap: {
          show: false,
          pieces: [
            { gt: 0, lte: 10000, color: "#ff0000" }, // 正值用红色
            { gt: -10000, lte: 0, color: "#26a374" }, // 负值用绿色
          ],
          dimension: 1,
        },
      };

      this.syChart.setOption(option);

      window.addEventListener("resize", () => this.syChart?.resize());
    },
  },
};
</script>

<style lang="less" scoped>
.yxbx_wrap {
  .title_box {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-weight: bold;
      font-size: 18px;
      display: flex;
      align-items: center;

      .icon {
        // padding-left: 6px;
        // padding-top: 3px;
        margin-left: 6px;
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }
  }

  .yxbx_box {
    margin-top: 36px;
    display: flex;
    justify-content: space-between;

    .title_box {
      /deep/ .bx_select {
        width: 70px;

        .el-select__wrapper {
          background-color: transparent;
          box-shadow: 0 0 0 2px #28324b inset;

          .el-select__placeholder {
            color: #fff;
          }
        }
      }
    }

    .yxbx_list {
      width: calc((100% - 24px) * 0.32);

      .bx_item {
        padding: 16px 20px;
        border: 2px solid #28324b;

        .item_box {
          margin-top: 16px;
          display: flex;

          .box {
            width: 50%;

            .sy {
              color: #ff0000;
              font-weight: bold;
              font-size: 18px;

              &.sy_ {
                color: #26a374;
              }
            }

            .title_box {
              margin-top: 6px;

              .title {
                font-weight: 400;
                font-size: 14px;

                .icon {
                  width: 14px;
                  height: 14px;
                }
              }
            }
          }
        }
      }

      .period_item {
        margin-top: 24px;
        padding: 16px 20px;
        border: 2px solid #28324b;

        .period_box {
          .period_echart {
            height: 300px;
          }
        }
      }
    }

    .yield_box {
      width: calc((100% - 24px) * 0.68);
      padding: 16px 20px;
      box-sizing: border-box;
      border: 2px solid #28324b;

      .sy_box {
        .sy_echart {
          height: 449px;
        }
      }
    }
  }

  .armory_box {
    margin-top: 36px;
    padding: 16px 20px;
    border: 2px solid #28324b;

    .armory_list {
      font-size: 14px;

      .armory_item {
        margin-top: 48px;

        .deal_box {
          margin-top: 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .left {
            .box {
              display: flex;

              div {
                margin-left: 50px;

                &:first-child {
                  margin-left: 0;
                }
              }

              &.sell_box {
                margin-top: 24px;
              }
            }
          }

          .right {
            display: flex;
            font-size: 18px;
            font-weight: bold;

            .cycle {
              margin-right: 100px;
            }

            .profit {
              width: 205px;

              span {
                color: #ff0000;

                &.sp {
                  color: #26a374;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>